<template>
  <footer class="footer">
    <div class="container">
      <div class="copyright text-center">
        &copy; {{ new Date().getFullYear() }} <a href="https://exportai.me" class="text-primary" target="_blank">Export.ai</a> <i class="fas fa-building"></i>
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style></style>
